export const useDefaultMeta = () => {
  const config = useRuntimeConfig()
  const { $t, $lang } = useNuxtApp()
  const rootStore = useRootStore()

  const baseUrl =
    process.env.NODE_ENV === 'production'
      ? 'https://www.gutsgusto.com/' + rootStore.lang
      : 'http://localhost'

  const linkData = [{
    key: 'manifest',
    rel: 'manifest',
    href: '/manifest.webmanifest'
  }]
  linkData.push({
    key: 'canonical',
    rel: 'canonical',
    href: 'https://www.gutsgusto.com/' + rootStore.lang
  })
  rootStore.languages.forEach(lang => {
    linkData.push({
      key: 'alternate-' + lang,
      rel: 'alternate',
      hreflang: lang,
      href: 'https://www.gutsgusto.com/' + lang
    })
  })
  linkData.push({
    key: 'alternate-x-default',
    rel: 'alternate',
    hreflang: 'x-default',
    href: 'https://www.gutsgusto.com/en'
  })

  useHead({
    link: linkData,
    titleTemplate: titleChunk => {
      if (!titleChunk) { return null }
      let append = ''
      if (titleChunk.length < 54) {
        append += ' | Guts & Gusto'
      }
      if (titleChunk.length < 38) {
        append += ' | GUTSGUSTO.COM'
      }
      return `${titleChunk}${append}`
    },
    meta: [
      {
        key: 'og:locale',
        property: 'og:locale',
        content: $lang
      },
      { key: 'og:url', property: 'og:url', content: baseUrl },
      { key: 'og:title', property: 'og:title', content: 'Guts & Gusto' },
      {
        key: 'og:image',
        property: 'og:image',
        content: `${config.public.cdnURL}pictures/opengraph/general.jpg`
      },
      { key: 'og:image:width', property: 'og:image:width', content: 960 },
      { key: 'og:image:height', property: 'og:image:height', content: 960 },
      { key: 'og:alt', property: 'og:alt', content: 'GUTSGUSTO.COM' },
      {
        key: 'og:description',
        property: 'og:description',
        content: $t('general/metatags-global-meta-description')
      },
      {
        key: 'description',
        name: 'description',
        content: $t('general/metatags-global-meta-description')
      },
      {
        key: 'og:site_name',
        property: 'og:site_name',
        content: 'Guts & Gusto'
      },
      { key: 'og:type', property: 'og:type', content: 'website' },
      {
        key: 'name',
        name: 'name',
        content: 'Guts & Gusto'
      },
      {
        key: 'mobile-app-ios',
        name: 'mobile-app-ios',
        content: 'yes'
      },
      {
        key: 'apple-mobile-web-app-status-bar-style',
        name: 'apple-mobile-web-app-status-bar-style',
        content: 'standalone'
      },
      {
        key: 'mobile-app',
        name: 'mobile-app',
        content: 'yes'
      }
    ],
    htmlAttrs: {
      lang: rootStore.lang
    }
  })
}
